import React from 'react';
import { ReactComponent as AdminIcon } from '../img/admin.svg';
import { ReactComponent as StaffIcon } from '../img/staff1.svg';
import { ReactComponent as StudentIcon } from '../img/student.svg';


const UserCard = ({ name, text, icon, onClick }) => {
  const renderIcon = () => {
    const iconStyle = {
      filter: 'drop-shadow(0 0 8px rgba(100, 210, 255, 0.7))'
    };

    switch (icon) {
      case 'admin':
        return <AdminIcon className="user-card-icon" style={iconStyle} />;
      case 'staff':
        return <StaffIcon className="user-card-icon" style={iconStyle} />;
      case 'student':
        return <StudentIcon className="user-card-icon" style={iconStyle} />;
      default:
        return null;
    }
  };

  return (
    <div className="user-card-wrapper">
      <div 
        className="user-card-futuristic"
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => e.key === 'Enter' && onClick()}
      >
        <div className="user-card-glow"></div>
        <div className="user-card-icon-container">
          {renderIcon()}
        </div>
        <div className="user-card-content">
          <h3 className="user-card-title">{name}</h3>
          <p className="user-card-description">{text}</p>
        </div>
        <div className="user-card-underline"></div>
      </div>
    </div>
  );
};

export default UserCard;